import React from "react";
import { GACntxt } from "../../AllianceApp";

const Profile = () =>
{
    const userContext = React.useContext(GACntxt);

    if(userContext.userAuth0UserName)
    {
        return(
            <React.Fragment>
                <div>
                    <img src={userContext.userAuth0Picture} alt={userContext.userAuth0UserName} />
                    <h2>Name: {userContext.userAuth0UserName}</h2>
                    <p>e-mail: {userContext.userAuth0Email}</p>
                    <h3>User Metadata</h3>
                    {userContext.userMetadata ? (<pre>{JSON.stringify(userContext.userMetadata, null, 2)}</pre>) : ("No user metadata defined")}
                </div>
            </React.Fragment>
        );
    }
    else
    {
        return(
            <React.Fragment>
                <div>Unable to retrieve user data.</div>
            </React.Fragment>
        );
    }
};
export default Profile;